import { Injectable } from '@angular/core';
import { IUpdateTakeImage } from '../../../../../services/http-models/project/take/take-http-request-model';
import { BehaviorSubject, Observable } from 'rxjs';
import { IAssetCollectionService } from '../../../../../components/shared/major/photos-collection/photos-list/photo-list-model';
import { ICallbacksForPickAsset } from '../../project/shared-components/pick-new-asset-state-manager.base';
import { HttpErrorResponse } from '@angular/common/http';
import { IUploader } from '../../../../../constants/shared/uploader-service-unique-ids';
import { IGenerateVideoRequest } from '../../../../../services/http-models/asset/asset-http-request-model';
import { IGeneratedVideoSocketData } from '../../../../../models/socket-events/workspace/asset/workspace-asset-event';
import { IUpdateVideoLayerByAsset } from '../../../../../services/http-models/project/scene/scene-http-request-model';
import { ILocalAsset } from '../../../../../models/assets/assets.model';

export interface IAssetTitles {
    library: boolean;
    videoLibrary: boolean;
    generate: boolean;
    upload: boolean;
    generateVideo: boolean;
}

export interface IGeneratedAssetResponse {
    uploadPath: string;
    assetId: string;
    asset: ILocalAsset;
}
export type IAssetType = 'pdf' | 'video' | 'image' | 'all';
export interface IGenerateAssetFunctionParams {
    projectId?: string;
    prompt: string;
    assetId: string | null;
    model: string;
    aspectRatio: string;
    toUseLogo: boolean;
}
export interface IAssetMainService extends IUploader {
    photoService: IAssetCollectionService;
    asset: IAssetType;
    createNewAssetAsync: (updateImage: IUpdateTakeImage) => Promise<boolean> | null;
    useGeneratedAssetAsync?: (videoData: IUpdateVideoLayerByAsset) => Promise<boolean> | null;
    generateAssetAsync: (data: IGenerateAssetFunctionParams) => Promise<IGeneratedAssetResponse>;
    generateVideoAsync: (data: IGenerateVideoRequest) => Promise<{ success: boolean }>;
    generatedVideo$: Observable<IGeneratedVideoSocketData>;
    onFileDrop: (formData: FormData) => Promise<{ data: any; error: Error | HttpErrorResponse }>;
    callbacks: ICallbacksForPickAsset;
    onCloseButtonClicked: () => void;
    displayTitles: IAssetTitles;
    toDisplayHeader: boolean;
    toDisplayUseMeButtonWithVideoGenerating?: boolean;
    toDisplayUseMeButtonWithImageGenerating?: boolean;
    toDisplayExtendVideoOption?: boolean;
    toDisplayIncludeLogoOption?: boolean;
    initialGenerateImagePrompt: string;
    toDisplaySelectAsset: boolean;
    toDisplayExitButton: boolean;
    toMakeUploadAsMainButton?: boolean;
    isUploading: boolean;
    isHosted: boolean;
    toDisplayLoading: boolean;
    toEnableImageToVideo: boolean;
    toEnableEditImage: boolean;
    uploadImageFromGenerateImage?: (formData: FormData) => Promise<{ data: any; error: Error | HttpErrorResponse }>;
    selectImageFromAssetLibraryInGenerateImage?: (
        asset: ILocalAsset
    ) => Promise<{ data: any; error: Error | HttpErrorResponse }>;
}

@Injectable()
export class AssetsMainManagerService {
    private _assetMainConfigsSubject = new BehaviorSubject<IAssetMainService>(null);
    public assetMainConfigs$ = this._assetMainConfigsSubject.asObservable();

    constructor() {}

    setAssetMainConfigs(assetMainConfigs: IAssetMainService) {
        this._assetMainConfigsSubject.next(assetMainConfigs);
    }
}
